


























































import { Component, Prop, Vue } from 'vue-property-decorator';
import Topic from '../../components/topic.vue'
let timer = 0;
let time = 0;
let beginTime = 0;
let formalId = 0;
let token = "";

@Component({ components: { Topic } })
export default class Formal extends Vue {
    private loading = false;

    private pagedData = [];

    private topics: any[] = [];
    private singleNum = 0;
    private multipleNum = 0;
    private judgeNum = 0;
    private myAnswers: any[] = [];
    private status = 0;
    private help = false;
    private resultTip = "";

    formatTimer(row: any, column: any, cellValue: number) {
        if (row.autoStart) {
            let date = new Date(cellValue);
            let y = date.getFullYear();
            let MM = date.getMonth() + 1;
            let d = date.getDate();
            let h = date.getHours();
            let m = date.getMinutes();
            let s = date.getSeconds();
            return `${y}.${MM}.${d} ${h}:${m}`;
        }
        else
            return "";
    }

    created() {
        this.help = this.$store.state.help;
        console.log(this.help)
        this.reload();
    }

    destroyed() {
        // 页面摧毁
        clearInterval(timer);
        timer = 0;
        window.removeEventListener('beforeunload', this.beforeunloadFn);
    }

    beforeunloadFn(e: any) {
        // 这个事件只有在鼠标真正和浏览器有了交互，再刷新或者关闭时才会触发, 浏览器事件会弹框确认用户是否要离开页面
        e = e || window.event
        if (e) {
            e.returnValue = '关闭提示'
        }
        return '关闭提示'
    }

    reload() {
        this.$apis.getMyFormals()
            .then((res: any) => {
                this.pagedData = res.data;
            });
    }

    onMove(index: number) {
        let el = document.getElementById(`topic${index}`);
        if (el) {
            el.scrollIntoView({ behavior: "smooth", block: "start" });
        }
    }

    onMyAnswer(index: number, value: string) {
        this.$set(this.myAnswers, index, value)
        //this.myAnswers[index] = value;
        //this.$forceUpdate()
    }

    onBegin(id: number) {
        
        formalId = id;
        this.$apis.postFormal2(id, this.$store.state.machineId)
            .then((res: any) => {
                this.singleNum = res.data.singleNum;
                this.multipleNum = res.data.multipleNum;
                this.judgeNum = res.data.judgeNum;
                this.topics = res.data.topics;
                this.myAnswers = (new Array(this.topics.length)).fill('');
                this.status = 1;

                // 记录令牌，防止作弊
                token = res.data.token;

                // 获取剩余时间，并记录开始考试时间
                time = res.data.time;
                beginTime = new Date().getTime();

                // 清除定时器
                if (timer)
                    clearInterval(timer);

                // 启动定时器
                this.resultTip = `${Math.floor(time / 60)}分${time % 60}秒`;
                timer = setInterval(() => {
                    let remainingTime = time - Math.trunc((new Date().getTime() - beginTime)/1000);
                    if (remainingTime <= 0) {
                        this.onFinish();
                    }
                    else {
                        this.resultTip = `${Math.floor(remainingTime / 60)}分${remainingTime % 60}秒`;
                    }
                }, 1000);

                // 页面渲染完成
                window.addEventListener('beforeunload', this.beforeunloadFn)
            });
    }

    onSuccess() {
        if (this.help) {
            // 上传成绩
            this.$apis.getMyFormalAnswer(formalId)
                .then((res: any) => {
                for (let i = 0; i < this.topics.length; ++i) {
                    (this.$refs[`topic${i}`] as any)[0].setMyAnswer(res.data[i]);
                    this.myAnswers[i] = res.data[i];
                }
            });
        }
    }

    onFinish() {
        this.help = false;
        clearInterval(timer);
        timer = 0;
        window.removeEventListener('beforeunload', this.beforeunloadFn);

        // 上传成绩
        this.$apis.putFormal2(formalId, this.$store.state.machineId, { token: token, myAnswers: this.myAnswers })
            .then((res: any) => {
            this.status = 0;

            /*for (let i = 0; i < this.topics.length; ++i) {
                (this.$refs[`topic${i}`] as any)[0].show(true);
            }*/

            this.resultTip = `你的得分：${res.data.score}，用时：${Math.floor(res.data.usedTime / 60)}分${res.data.usedTime % 60}秒`;
            alert(`你的得分：${res.data.score}，用时：${Math.floor(res.data.usedTime / 60)}分${res.data.usedTime % 60}秒`);
        });
    }
}
